module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "team-members row"
  }, _vm._l((_vm.partArray), function(item, index) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.onSelect(item.childurl)
        }
      }
    }, [_c('router-link', {
      staticClass: "fb-touch",
      attrs: {
        "to": {
          path: item.childurl
        }
      }
    }, [_c('div', {
      staticClass: "single-member effect-1"
    }, [_c('div', {
      staticClass: "member-image"
    }, [_c('img', {
      attrs: {
        "src": item.nodedesc,
        "alt": "Member"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "member-info"
    }, [_c('h3', {
      staticClass: "index-itemh3"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "social-touch"
    })])])])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19070838!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 1038
// module chunks = 2